import { Alert, Box, Heading, Inline, Stack } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { useOutletContext } from "../../../../router-utils"
import {
	ForbidUnlessAuthorized,
	useHasFeatureFlag,
	PERMISSIONS,
} from "../../../../Auth"
import {
	ChannelManagerIcon,
	ChannelManagerSimulator,
	getChannelManagerName,
} from "../../../../ChannelManagers"
import { IHotel } from "../../../../Hotels"

export default function ChannelManagerSimulatorPage() {
	const { hotel } = useOutletContext<{
		hotel: IHotel
	}>()
	const hasSimulator = useHasFeatureFlag("cm_simulator")
	// name the page after whatever channel manager the hotel actually use
	const channelManagerName = getChannelManagerName(hotel.channel_manager)
	const title = channelManagerName
		? `${channelManagerName} Simulator`
		: "Channel Manager Simulator"
	return (
		<>
			<Helmet>
				<title>{title} | Hotel</title>
			</Helmet>
			<Box padding="6" bgColor="default" roundedBottom="md">
				{/* the simulator write real inventory and rates, so keep it to
				admins of tenants where it is switched on */}
				<ForbidUnlessAuthorized anyPermissions={[PERMISSIONS.MANAGE_USERS]}>
					<Stack gap="4">
						<Inline gap="2" alignItems="center">
							<ChannelManagerIcon
								channelManager={hotel.channel_manager}
								size="32px"
							/>
							<Heading as="h4">{title}</Heading>
						</Inline>
						{hasSimulator ? (
							<ChannelManagerSimulator hotel={hotel} />
						) : (
							<Alert status="info" title="Simulator not enabled">
								The channel manager simulator is not enabled for your
								organization. Please contact Sembark support if you need it for
								testing.
							</Alert>
						)}
					</Stack>
				</ForbidUnlessAuthorized>
			</Box>
		</>
	)
}
